import { FIELD_TYPES } from 'src/tpbp-core/models/fields/field-set.const'
import type {
  FieldInterface,
  RelationInterface,
} from 'src/tpbp-configuration/mapper/mappingInterfaces'

const productGroupConfigurationFields: FieldInterface[] = [
  {
    key: 'productGroup',
    originKey: 'product_group',
    type: FIELD_TYPES.string,
  },
  {
    key: 'productGroupLabel',
    originKey: 'product_group_label',
    type: FIELD_TYPES.string,
  },
  {
    key: 'productGroupOrder',
    originKey: 'product_group_order',
    type: FIELD_TYPES.number,
  },
]

const productGroupConfigurationRelations: RelationInterface[] = []

export { productGroupConfigurationFields, productGroupConfigurationRelations }
